
class templateSetUpCtrl {
    constructor($scope, $state, httpRequest, $uibModal, Upload, logger, $timeout, sweetalert) {
        // 下拉配置
        $scope.tableDropdownConfig = [
            {
                label: '预览',
                handler(item) {
                    $uibModal.open({
                        template: require('./view/previewTemplateSetUp.html'),
                        openedClass: 'mod-modal mod-modal-preview',
                        controller: 'previewTemplateCtrl',
                        animation: true,
                        resolve: {
                            obj() {
                                return item
                            },
                        },
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('add_template_set_up,edit_template_set_up,use_template_set_up,export_template_set_up,delete_template_set_up,preview_template_set_up')
                },
            }, {
                label: '编辑',
                handler(item) {
                    $state.go('system.settingcenter.templateSetUp.edit', { templateId: item.templateId })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('edit_template_set_up')
                },
            }, {
                label: '启用',
                handler(item) {
                    item.status = 1
                    httpRequest.get_updateContractTemplateStatus({ templateId: item.templateId, status: item.status }).then((res) => {
                        if (res.data.success) $scope.queryList()
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('use_template_set_up') && item.status == 0
                },
            }, {
                label: '禁用',
                handler(item) {
                    item.status = 0
                    httpRequest.get_updateContractTemplateStatus({ templateId: item.templateId, status: item.status }).then((res) => {
                        if (res.data.success) $scope.queryList()
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('use_template_set_up') && item.status == 1
                },
            }, {
                label: '导出',
                handler(item) {
                    const url = `${host.etcloudIvatApp}contract/contractTemplate/exportTo?templateId=${item.templateId}&accessToken=${localStorage.id_token}`
                    window.open(url, '_blank')
                },
                showWhile(item, hasPermit) {
                    return hasPermit('export_template_set_up')
                },
            }, {
                label: '删除',
                handler(item) {
                    sweetalert.confirm('删除提醒', '请确认是否删除该模版').then(() => {
                        httpRequest.get_delContractTemplate(item.templateId).then((res) => {
                            if (res.data.success) {
                                logger.logSuccess('删除成功')
                                $scope.queryList()
                            }
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('delete_template_set_up')
                },
            },
        ]
        $scope.params = {
            pageNum: 1,
            pageSize: 10,
            param: {
                bizName: '',
                bizType: '',
                endTime: '',
                orgId: '',
                startTime: '',
                status: '',
                templateId: '',
            },
        }
        // 查询参数
        $scope.reset = function () {
            $scope.params.param = {
                bizName: '',
                bizType: '',
                endTime: '',
                orgId: '',
                startTime: '',
                status: '',
                templateId: '',
            }
        }
        // $scope.reset()
        // 字典值
        httpRequest.get_dictByTypeArr(['biz_type', 'contract_template_status']).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.add = function add() {
            $state.go('system.settingcenter.templateSetUp.add')
        }
        $scope.queryList = function queryList() {
            $scope.params = sessionStorage.templateParam ? JSON.parse(sessionStorage.templateParam) : $scope.params
            httpRequest.post_getContractTemplateList($scope.params).then((res) => {
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
                $scope.params.pageNum = res.data.value.pageNum
            })
        }
        $scope.searchList = function () {
            sessionStorage.setItem('templateParam', JSON.stringify($scope.params))
            $scope.queryList()
        }
        // 分页
        $scope.pageChanged = function () { // 点击页码发起查询
            sessionStorage.setItem('templateParam', JSON.stringify(
                {
                    orderMap: $scope.params.orderMap,
                    pageNum: $scope.params.pageNum,
                    pageSize: $scope.params.pageSize,
                    param: sessionStorage.templateParam ? JSON.parse(sessionStorage.templateParam).param : {
                        bizName: '',
                        bizType: '',
                        endTime: '',
                        orgId: '',
                        startTime: '',
                        status: '',
                        templateId: '',
                    },
                },
            ))
            $scope.queryList()
        }
        $scope.queryList()
        $scope.uploadFiles = function (file, errFiles) {
            // 不符合文件格式的错误提示
            if (file == null && errFiles.length >= 1) {
                logger.logError('导入的文件格式错误，只支持.json格式，文件大小不超过50M，请重新导入')
                return
            }
            if (file) {
                file.upload = Upload.upload({
                    url: `${host.etcloudIvatApp}contract/contractTemplate/importTemplate`,
                    data: {
                        importFile: file,
                        // fileName: encodeURI(file.name),
                    },
                })
                // 文件上传
                // loading动画
                const importinglayer = layer.msg('玩命上传中，请耐心等待', {
                    time: 0, skin: 'layer-loading-self', icon: 16, shade: 0.5,
                })
                file.upload.then((res) => {
                    $timeout(() => {
                        // 关闭loading
                        layer.close(importinglayer)
                        if (!res.data.success) {
                            return logger.logError(res.data.message || '上传失败')
                        }
                        $scope.queryList()
                    })
                }, (response) => {
                    if (response.status > 0) {
                        // 关闭loading
                        layer.close(importinglayer)
                        logger.logError('上传失败 ')
                    }
                }, (evt) => {
                    file.progress = Math.min(100, parseInt((100.0 * evt.loaded) / evt.total))
                })
            }
        }
    }
}

templateSetUpCtrl.$inject = ['$scope', '$state', 'httpRequest', '$uibModal', 'Upload', 'logger', '$timeout', 'sweetalert']
export default templateSetUpCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/templateSetUp/templateSetUpCtrl.js